<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    POOL SETTINGS
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <ResourcePoolMenu :collapsed="collapsed" />

                <v-list-item :class="{ 'ml-2 drawer-active-item': !collapsed }" active-class="primary--text" :to="generalRoute" :disabled="!generalRoute">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-cog-outline</v-icon>
                            </template>
                            <span>General</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>General</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :class="{ 'ml-2 drawer-active-item': !collapsed }" active-class="primary--text" :to="usersRoute" :disabled="!usersRoute">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-account-group-outline</v-icon>
                            </template>
                            <span>Users</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Users</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="isResourcePoolManager && !collapsed" class="my-0">
                        <ResourcePoolInviteDialog ref="drawerPoolInviteDialog">
                            <template v-slot:activator>
                                <v-btn text small class="px-2" min-width="0" @click.stop.prevent="openPoolInviteFromDrawer">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </ResourcePoolInviteDialog>
                    </v-list-item-action>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

const ResourcePoolMenu = () => import('@/modules/user/components/ResourcePoolMenu.vue')
const ResourcePoolInviteDialog = () => import('@/modules/user/components/ResourcePoolInviteDialog.vue')

export default {
    name: 'DrawerPoolSettingsSection',
    components: {
        ResourcePoolMenu,
        ResourcePoolInviteDialog
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('userStore', ['isResourcePoolManager']),
        ...mapState(['userOrgs', 'currentOrgData']),
        ...mapState('userStore', ['selectedResourcePool', 'availableResourcePools']),
        currentOrgOid() {
            return this.$route.params.oid || this.currentOrgData?.oid || this.userOrgs[0]?.oid
        },
        activeResourcePoolId() {
            return Number(this.$route.params.rpid || this.selectedResourcePool || this.availableResourcePools[0]?.rpid)
        },
        generalRoute() {
            if (!this.currentOrgOid || !this.activeResourcePoolId) {
                return null
            }

            return {
                name: 'config-pool-general',
                params: {
                    oid: this.currentOrgOid,
                    rpid: this.activeResourcePoolId
                }
            }
        },
        usersRoute() {
            if (!this.currentOrgOid || !this.activeResourcePoolId) {
                return null
            }

            return {
                name: 'config-pool-users',
                params: {
                    oid: this.currentOrgOid,
                    rpid: this.activeResourcePoolId
                }
            }
        }
    },
    methods: {
        openPoolInviteFromDrawer() {
            const inviteDialog = this.$refs.drawerPoolInviteDialog
            if (inviteDialog && inviteDialog.openDialog) {
                inviteDialog.openDialog()
            }
        }
    }
}
</script>
